// 颜色选择器
// https://github.com/xiaokaike/vue-color

import Vue from "vue"
import { Sketch } from 'vue-color'
Vue.component("photoshop-picker",Sketch)



// WEBPACK FOOTER //
// ./src/_dependency/vue-color-kit.js